<template>
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1761_228)">
<rect width="20" height="20" fill="#FEFEFF"/>
<path d="M1.09033 18.9998L18.9094 1.18066" stroke="#BD3531" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1.09033 1L18.9094 18.8191" stroke="#BD3531" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_1761_228">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>
</template>

<script>
export default {
  name: 'IconClose'
}
</script>
